import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {ComponentTabs} from "../../models/component-tabs";
import Helpers from "../../utils/helpers";

@Injectable()
export class ComponentTabControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public get(serviceId: string, key: string): Observable<ComponentTabs> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/componenttabs/" + key) as Observable<ComponentTabs>;
  }

  public getById(id: string): Observable<ComponentTabs> {
    return this.http.get(this.baseUrl + "componenttabs/" + id) as Observable<ComponentTabs>;
  }

  public save(serviceId: string, key: string, componentTabs: ComponentTabs): Observable<ComponentTabs> {
    Helpers.trimRecursiveObj(componentTabs);
    const body = JSON.stringify(componentTabs);
    return this.http.put(this.baseUrl + "service/" + serviceId + "/componenttabs/" + key, body) as Observable<ComponentTabs>;
  }

  public saveById(id, componentTabs: ComponentTabs): Observable<ComponentTabs> {
    Helpers.trimRecursiveObj(componentTabs);
    const body = JSON.stringify(componentTabs);
    return this.http.put(this.baseUrl + "componenttabs/" + id, body) as Observable<ComponentTabs>;
  }

}
